export default async function wait<T>(
  callback: () => T | Promise<T>,
): Promise<T> {
  try {
    document.body.classList.add('wait');
    const result = await new Promise<T>((resolve, reject) => {
      setTimeout(async function () {
        try {
          const result = await callback();
          resolve(result);
        } catch (err) {
          if (err instanceof DOMException && err.name === 'NotAllowedError') {
            reject(err);
          } else {
            throw err;
          }
        }
      }, 0);
    });
    return result;
  } finally {
    document.body.classList.remove('wait');
  }
}
